<div class="form-group">
  @if (showLabel && (labelText || question?.question_prompt || question?.email_version)) {
    <label class="form-group__label">
      {{question?.question_prompt ? question?.question_prompt : question?.email_version ? question?.email_version : labelText}}
    </label>
  }

  <!-- <label class="custom-input custom-input--radio custom-input--categories" *ngFor="let item of items">
  <input type="radio"
    [name]="uniqueControlName"
    (click)="checkRadio(item?.answer)"
    [disabled]="item?.disabled === 1"
    [checked]=" (item?.answer == question?.answer.split('|')) ">
    <span class="custom-input__indi"></span>
    <span class="custom-input__label">
      <span>
        {{item?.answer}}
        <a *ngIf="item.showPopover" class="popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover" data-trigger="focus"
          data-html="true" data-placement="bottom" data-original-title="" title=""
          data-content="<div class=&quot;popover__content&quot;>Tooltip content can go over here. Tooltip content can go over here.</div>">
          <svg class="icon icon--sm">
            <use xlink:href="#help-Icon"></use>
          </svg>
        </a>
      </span>
      <img *ngIf="item?.image_url" [src]="item.image_url" class="icon">
      <span class="custom-input__class" *ngIf="item?.info_comment">
        <svg class="icon">
          <use xlink:href="#info-small"></use>
        </svg>
        <span>{{item.info_comment}}</span>
      </span>
    </span>
  </label> -->


  @for (item of items; track item) {
    <label class="tile">
      <input type="radio"
        [name]="uniqueControlName"
        (click)="checkRadio(item?.answer)"
        [disabled]="readOnly || item?.disabled === 1"
        [checked]=" (item?.answer == question?.answer.split('|')) ">
        <div class="tile__inner">
          <div class="tile__main">
            <div class="tile__content">
              <div class="tile__indi"><span></span></div>
              <div class="tile__label">
                <div class="tile__title">{{item?.answer}}</div>
                <div class="tile__subtitle">{{item?.info_comment}}</div>
              </div>
            </div>
            <div class="tile__right">
              @if (item?.showPopover) {
                <a class="popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
                  data-trigger="focus" data-html="true" data-placement="bottom"
                  data-content="<div class=&quot;popover__content&quot;>Tooltip content can go over here. Tooltip content can go over here.</div>"
                  data-original-title="" title="">
                  <svg class="icon icon--sm">
                    <use xlink:href="#help-Icon"></use>
                  </svg>
                </a>
              }
              @if (item?.image_url) {
                <img [src]="item?.image_url" class="icon icon--lg-xl" alt="">
              }
            </div>
          </div>
        </div>
      </label>
    }
  </div>